import { service } from "@ember/service";
import Component from "@glimmer/component";

import Dropdown from "glesys-controlpanel/components/dropdown";
import DropdownItem from "glesys-controlpanel/components/dropdown/item";
import DropdownLinkItem from "glesys-controlpanel/components/dropdown/link-item";

import IconsFaq from "glesys-controlpanel/components/icons/faq";
import { t } from "ember-intl";
import { on } from "@ember/modifier";
import modal from "glesys-controlpanel/helpers/modal";
import { not } from "ember-truth-helpers";

export default class HelpDropdown extends Component {
  @service help;

  <template>
    <Dropdown
      aria-label={{t "component.help-dropdown.aria-label"}}
      data-test-help-dropdown
      data-test-help-dropdown-disabled="{{not this.help.topicsForCurrentRoute}}"
      @chevron={{false}}
      ...attributes
    >
      <:header>
        <IconsFaq class="w-6 {{unless this.help.topicsForCurrentRoute 'opacity-75' ''}}" />
      </:header>
      <:default>
        {{#each this.help.topicsForCurrentRoute as |topic|}}
          <DropdownItem
            data-test-help-dropdown-value={{topic.title}}
            {{on "click" (modal "modals/help-topic" topic=topic)}}
          >
            {{topic.title}}
          </DropdownItem>
        {{else}}
          <DropdownLinkItem
            class="text-gray-500"
            aria-label={{t "component.help-dropdown.not-available-aria-label"}}
            href={{t "component.help-dropdown.link"}}
            target="_blank"
            rel="noopener noreferrer"
          >
            {{t "component.help-dropdown.not-available"}}
          </DropdownLinkItem>
        {{/each}}
      </:default>
    </Dropdown>
  </template>
}
